import { combineEpics } from 'redux-observable';
import { employmentTypesEpic, departmentRolesEpic } from './epics';

export default combineEpics(employmentTypesEpic, departmentRolesEpic);
